import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { PageSpinner } from '@/shared/ui/PageSpinner';
import { Alert } from '@/shared/ui';
import { tendersApi } from '@/shared/api/endpoints/tenders';

const ONBOARDING_PATH = '/app/tenders/onboarding';

export function TenderCabinetGuard() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [ready, setReady] = useState(false);
  const [statusError, setStatusError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setStatusError(false);
    tendersApi
      .onboardingStatus()
      .then((s) => {
        if (!cancelled) setReady(Boolean(s.ready));
      })
      .catch(() => {
        // Do not treat transient API failures as "no company" — that shows an empty form.
        if (!cancelled) setStatusError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [location.pathname]);

  if (loading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <PageSpinner />
      </div>
    );
  }

  if (statusError) {
    return (
      <div className="mx-auto max-w-lg p-6">
        <Alert variant="error">
          Сервис временно недоступен. Данные компании не удалены — обновите страницу через минуту.
        </Alert>
      </div>
    );
  }

  if (!ready && location.pathname !== ONBOARDING_PATH) {
    return <Navigate to={ONBOARDING_PATH} replace state={{ from: location }} />;
  }

  if (ready && location.pathname === ONBOARDING_PATH) {
    return <Navigate to="/app/dashboard" replace />;
  }

  return <Outlet />;
}
